export default __webpack_public_path__ + "static/media/Nocturno.34d88c01.png";